import { Zap, Bot, Plug, Search, Brain } from "../../../icons"
import { IntentBadge } from "../../status-badge"

interface BadgeProps {
  has_compaction?: boolean
  uses_task_agent?: boolean
  uses_mcp?: boolean
  uses_web_search?: boolean
  uses_web_fetch?: boolean
  has_thinking?: boolean
}

// Capability chips reuse the canonical tag (IntentBadge → Badge) for size and
// shape, but keep their lowercase + icon identity via `normal-case`. This keeps
// them the same scale as status tags instead of the old oversized type-body pill.
const ICON_CLASS = 'shrink-0'

export function SessionBadges({
  has_compaction,
  uses_task_agent,
  uses_mcp,
  uses_web_search,
  uses_web_fetch,
  has_thinking,
}: BadgeProps) {
  return (
    <div className="flex flex-wrap gap-1">
      {has_compaction && (
        <IntentBadge intent="neutral" className="normal-case gap-1">
          <Zap className={ICON_CLASS} strokeWidth={1.5} /> compacted
        </IntentBadge>
      )}
      {uses_task_agent && (
        <IntentBadge intent="neutral" className="normal-case gap-1">
          <Bot className={ICON_CLASS} strokeWidth={1.5} /> agent
        </IntentBadge>
      )}
      {uses_mcp && (
        <IntentBadge intent="neutral" className="normal-case gap-1">
          <Plug className={ICON_CLASS} strokeWidth={1.5} /> mcp
        </IntentBadge>
      )}
      {(uses_web_search || uses_web_fetch) && (
        <IntentBadge intent="neutral" className="normal-case gap-1">
          <Search className={ICON_CLASS} strokeWidth={1.5} /> web
        </IntentBadge>
      )}
      {has_thinking && (
        <IntentBadge intent="neutral" className="normal-case gap-1">
          <Brain className={ICON_CLASS} strokeWidth={1.5} /> thinking
        </IntentBadge>
      )}
    </div>
  )
}
